import Image from 'next/image';
import { getEdgeUrl } from '@/lib/getEdgeUrl';
import i18n from '@/settings/i18n';

const t = i18n.init('about');

const Hero = () => (
  <div className="relative h-[200px] overflow-hidden bg-teal-500 lg:h-[300px]">
    <div className="absolute z-10 h-full w-full">
      <div className="mx-auto flex h-full w-full items-center justify-center p-5 xxs:mx-0 xxs:w-[300px] xs:w-[375px] xs:p-10 sm:mx-auto md:w-[400px] lg:w-[450px] xl:w-[500px]">
        <h1 className="text-center text-xl font-bold xxs:text-left xs:text-2xl sm:text-center lg:text-3xl xl:text-4xl">
          {t`Your Destination for Affordable & Sustainable Shopping`}
        </h1>
      </div>
    </div>
    <div className="absolute h-full w-full bg-[url('/images/about/hero.svg')] bg-contain bg-repeat"></div>
    <div className="absolute left-0 hidden h-full sm:block">
      <Image
        src={getEdgeUrl('images/about-us/hero/desktop-left.png')}
        height={1000}
        width={900}
        className="h-full w-auto"
        alt={t`Left Gadgets`}
        quality={100}
      />
    </div>
    <div className="absolute right-0 hidden h-full sm:block">
      <Image
        src={getEdgeUrl('images/about-us/hero/right-desktop.png')}
        height={1000}
        width={900}
        className="h-full w-auto"
        alt={t`Right Gadgets`}
        quality={100}
      />
    </div>
    <div className="absolute right-0 h-full opacity-40 xxs:opacity-100 sm:hidden">
      <Image
        src={getEdgeUrl('images/about-us/hero/right-mobile.png')}
        height={480}
        width={410}
        className="h-full w-auto"
        alt={t`Right Gadgets`}
        quality={100}
      />
    </div>
  </div>
);

export default Hero;
